import Drawer from 'react-modern-drawer';
import { Modal } from 'react-responsive-modal';

export default function VerifyData(param: any) {


    const onCloseDrawer = () => {
        param.VerifyDataChange();
    }

    const performersData = [
        {
            id: 1,
            performer: "Adam Brown",
            character: "Anne",
            roleParticipation: "SR",
            episode: "SR",
            status: {
                type: "ready",
                label: "Ready",
                message: null,
            },
        },
        {
            id: 2,
            performer: "Ben Smith",
            character: "John Carson",
            roleParticipation: "PR",
            episode: "PR",
            status: {
                type: "warning",
                label: "Warning",
                message: "New Producer not recognized.",
            },
        },
        {
            id: 3,
            performer: "Chloe White",
            character: "White",
            roleParticipation: "CO",
            episode: "GR",
            status: {
                type: "error",
                label: "Error",
                message: "Missing Performer ID / Missing character",
            },
        },
        {
            id: 4,
            performer: "Samantha Clark",
            character: "Denny",
            roleParticipation: "SR",
            episode: "SR",
            status: {
                type: "warning",
                label: "Warning",
                message: "Unlinked performer: Chloe White",
            },
        },
        {
            id: 5,
            performer: "Thomas Evans",
            character: "Evans",
            roleParticipation: "SR",
            episode: "GR",
            status: {
                type: "ready",
                label: "Ready",
                message: "Invalid character length, must be 2–4 characters",
            },
        },
        {
            id: 6,
            performer: "Laura Foster",
            character: "Laura",
            roleParticipation: "SR",
            episode: "SR",
            status: {
                type: "ready",
                label: "Ready",
                message: null,
            },
        },
        {
            id: 7,
            performer: "Megan Patel",
            character: "Megan",
            roleParticipation: "SR",
            episode: "CO",
            status: {
                type: "warning",
                label: "Warning",
                message: "Unlinked performer: Freddie Maclean",
            },
        },
        {
            id: 8,
            performer: "Andrew Davies",
            character: "Andrew",
            roleParticipation: "SR",
            episode: "GR",
            status: {
                type: "warning",
                label: "Warning",
                message: "Possible duplicate performer, requires review",
            },
        },
    ];

    return (
        <>

            <Modal open={param.VerifyDataOpen} onClose={() => onCloseDrawer()} styles={{ modalContainer: { background: 'transparent !important', width: "60% !important" } }} center classNames={{ overlay: '', modal: 'ws-10 pull-right bgTransparent' }} >
                <div className="box ws-12 pm landing">

                    <div className="ws-12 mbl">
                        <div className='ws-8'>
                            <span className="ws-12 text-bold text-xl"> Verify Cast List</span>
                            <span className="ws-12 ptl text-bold text-s turquoise dark">Review the cast list befor importing,address any issues,the commit to system</span>
                        </div>

                        <div className='ws-4'>
                            <button type="button" className=" icon-btn edit  text-bold pull-right height40 width100" >Commit</button>
                            <button type="button" className=" icon-btn close text-bold pull-right height40 width100" onClick={() => onCloseDrawer()}>Cancel</button>
                        </div>
                    </div>

                    <div className='ws-12 box pm'>
                        <div className='ws-4 '>
                            <div className='ws-12 '>
                                <h2 className='ws-7'>Cast Import Template.xlsx</h2>
                                <span className='mt ws-5 text-left'>sheet1</span>
                            </div>
                            <hr></hr>

                            <div className='ws-12 '>
                                <span className='ws-12 ps'> <i className='icon-tick1 paleTurquoise mr pr pull-left mt'> </i>  <span className='text-bold'>245</span> rows checked </span>
                                <span className='ws-12 ps'> <i className='icon-tick1 paleTurquoise mr pr pull-left mt'> </i>  <span className='text-bold'>245</span> new cast row </span>
                                <span className='ws-12 ps'> <i className='icon-tick1 paleTurquoise mr pr pull-left mt'> </i>  <span className='text-bold'>245</span> updates to existing casts </span>
                                <span className='ws-12 ps'> <i className='icon-tick1 paleTurquoise mr pr pull-left mt'> </i>  <span className='text-bold'>245</span> errors found </span>
                                <span className='ws-12 ps'> <i className='icon-tick1 paleTurquoise mr pr pull-left mt'> </i>  <span className='text-bold'>245</span> warnings flagged </span>
                            </div>

                        </div>

                        <div className='ws-8 pull-right mbl'>
                            <div className='ws-12 forceSingleLine pull-right box mtl pLarge text-l landing'>
                                <div className='w-15'><span className='text-bold text-m text-center pl ws-11'  > 245 Rows </span> <span className="pull-right text-bold">|</span></div>
                                <div className='w-20'><span className='text-bold text-m text-center success pl ws-11'  > 245 New Rows</span> <span className="pull-right text-bold">|</span></div>
                                <div className='w-20'><span className='text-bold text-m text-center warning ws-11'  > 245 Updates</span> <span className="pull-right text-bold">|</span></div>
                                <div className='w-20'><span className='text-bold text-m text-center danger ws-11'  > 245 Errors</span> <span className="pull-right text-bold">|</span></div>
                                <div className='w-20'><span className='text-bold text-m text-center warning ws-11'> 245 Warning</span></div>
                            </div>

                            <span className='mtxl ws-12'> Fields with issues are highlighted. Fix errors before continuing, review warnings marked in yellow.</span>

                            <div className='ws-12 mtxl'>
                                <button className='icon-btn edit height40'><i className='icon-download pt text-m prl'></i> Download error report (CSV) </button>

                                <div className='ws-8  '>
                                    <select className='ml pm pbl height40 ws-3 white text-bold icon-btn close pull-right'>
                                        <option> Filter </option>
                                    </select>

                                    <div className='ws-8 box ps height40 pull-right'>
                                        <div className='ws-12 pull-right'>
                                            <i className='icon-search text-m mt pl pt'></i>
                                            <input type="text" className="ws-11 pull-right height40" placeholder='Search by Production title,ID,Programme Number...' style={{ border: 'none', outline: 'none' }} />
                                        </div>
                                    </div>

                                </div>

                            </div>
                        </div>
                    </div>

                    <div className='ws-12 box mtl height50 darkGreylanding'>
                        <div className='ws-8 forceSingleLine pull-left pLarge text-l '>
                            <div className='w-15'><span className='text-bold text-m text-center pl ws-11'  > 245 Rows </span> <span className="pull-right text-bold">|</span></div>
                            <div className='w-20'><span className='text-bold text-m text-center success pl ws-11'  > 245 New Rows</span> <span className="pull-right text-bold">|</span></div>
                            <div className='w-20'><span className='text-bold text-m text-center warning ws-11'  > 245 Updates</span> <span className="pull-right text-bold">|</span></div>
                            <div className='w-20'><span className='text-bold text-m text-center danger ws-11'  > 245 Errors</span> <span className="pull-right text-bold">|</span></div>
                            <div className='w-20'><span className='text-bold text-m text-center warning ws-11'> 245 Warning</span></div>
                        </div>

                        <div className='ws-4'>
                            <div className='ws-12 ps height50 pull-right'>
                                <button className='icon-btn info pull-right height40'><i className='icon-params1'></i></button>

                                <div className='ws-10 pull-right box height40'>
                                    <i className='icon-search text-m mtl pll '></i>
                                    <input type="text" className="ws-11 pull-right height40" placeholder='Search' style={{ border: 'none', outline: 'none' }} />
                                </div>

                            </div>
                        </div>
                    </div>

                    <div className='ws-12 box mtl'>
                        <table className="newTable box">
                            <thead>
                                <tr>
                                    <th ><input type='checkbox' /></th>
                                    <th >Performer</th>
                                    <th >Character</th>
                                    <th >Role/Participation</th>
                                    <th >Episode</th>
                                    <th >Status</th>
                                    <th >Status</th>
                                </tr>
                            </thead>
                            <tbody>
                                {performersData.map((row: any) => (
                                    <tr>
                                        <td><input type='checkbox' /></td>
                                        <td>{row.performer}</td>
                                        <td>{row.character}</td>
                                        <td>{row.roleParticipation}</td>
                                        <td>{row.episode}</td>
                                        <td>


                                            {(row?.status?.label == 'Ready') && <div className='width120 height30'>
                                                <div className='bg-level7 ps text-center borderRadius-s height30'>
                                                    <i className='icon-tick1 white mt text-m pl'></i>
                                                    <span className='white text-m'>  {row.status.label}</span>
                                                </div>
                                            </div>}

                                            {(row?.status?.label == 'Warning') && <div className='width120 height30'>
                                                <div className='bg-level9 ps text-center borderRadius-s height30'>
                                                    <i className='icon-warning1 dark mt text-m pl'></i>
                                                    <span className='white text-m'> {row.status.label}</span>
                                                </div>
                                            </div>}

                                            {(row?.status?.label == 'Error') && <div className='width120 height30'>
                                                <div className='bg-level6 ps text-center borderRadius-s height30'>
                                                    <i className='icon-close white mt text-m pl'></i>
                                                    <span className='white text-m'> {row.status.label}</span>
                                                </div>
                                            </div>}
                                        </td>
                                        <td>{row?.status?.message ? row?.status?.message : row?.status?.label}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>

                </div>
            </Modal>
        </>

    )

}